
module.exports={
    'api_key':'4943c3ede73d4cd990451a07b2b15076'
}
